<template>
  <div :class="['go',{goMedia:dev}]">
    <img
      @click="handleGoBtn"
      :src="require('@/assets/img/loading/go.png')"
    >
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "goBtn",
  computed: {
    videoObj() {
      return this.$store.state.videoObj;
    },
    audioObj() {
      return this.$store.state.audioObj;
    },
    dev() {
      return this.$store.state.dev;
    }
  },
  methods: {
    ...mapActions(["loadingFn", "videoComFn"]),
    handleGoBtn() {
      this.loadingFn(false); // loading消失
      this.videoComFn(true); // video 出现
      this.videoObj.play(); // 播放视频

      this.audioObj.play(); // 音乐播放
      // this.audioObj.pause(); // 音乐暂停
      nie.config.stats.url.add(
        location.host + location.pathname + "/page1/",
        "踏足江湖按钮点击"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.go {
  @include LTRBcenter;
  @include wh(1.27rem);
  img {
    @include wh(100%);
  }
}
.goMedia {
  transform: translate(-50%, -50%) rotate(90deg);
}
</style>


